
import React, { lazy, startTransition, Suspense, useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import {  Header } from "./source/components";
        import Footer from "./source/components/Web-Screens/Layout-Sections/Footer";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { onMessage } from "firebase/messaging";
import { messaging } from "./firebase.config";
import { ToastContainer, toast } from "react-toastify";
import { actionType } from "./source/context/reducer";
import { useStateValue } from "./source/context/StateProvider";
import { getuserinformation } from "./utils/firebasefunctions";
import HeaderPublic from "./source/components/Web-Screens/Layout-Sections/Header";
import "react-toastify/dist/ReactToastify.css";
import Message from "./source/components/Message";
// import "./fonts/Poppins-Regular.ttf";
// import "./fonts/Poppins-Bold.ttf";
// import "./fonts/Poppins-Black.ttf";













  const LoginScreen = lazy(() => import("./source/screens/LoginContainer/LoginScreen"));
 const HomeContainer = lazy(() => import("./source/screens/HomeContainer"));
  const Dashboard = lazy(() => import("./source/screens/Dashboard"));
   const Messages = lazy(() => import("./source/screens/Messages"));
    const CreatCustomer = lazy(() => import("./source/screens/CreatCustomer"));
     const CreateWorkOrder = lazy(() => import("./source/screens/CreateWorkOrder"));
      const MarketPlace = lazy(() => import("./source/screens/MarketPlace"));
      const TaskCreation = lazy(() => import("./source/screens/TaskCreation"));
const ProjectDesignations = lazy(() => import("./source/screens/ProjectDesignations"));
const ProjectEmployees = lazy(() => import("./source/screens/ProjectEmployees"));

const AddEmployeeToProject = lazy(() => import("./source/screens/AddEmployeeToProject"));
const CreateProject = lazy(() => import("./source/screens/CreateProject"));
const Blogs = lazy(() => import("./source/screens/Blogs"));
const CreateEmployeeSchedule = lazy(() => import("./source/screens/CreateEmployeeSchedule"));
const LeaveRequest = lazy(() => import("./source/screens/LeaveRequest"));
const PrivacyPolicy = lazy(() => import("./source/screens/Privacy-policy"));

const NotFound = lazy(() => import("./source/screens/NotFound"));
const UpdateSlot = lazy(() => import("./source/screens/UpdateSlot"));
const EditProject = lazy(() => import("./source/screens/EditProject"));
const Slots = lazy(() => import("./source/screens/Slots"));
const CreateVehichle = lazy(() => import("./source/screens/CreateVehichle"));
const WebScreens = lazy(() => import("./source/screens/WebScreen"));
const ToDolist = lazy(() => import("./source/screens/ToDolist"));
const CreateExpressDelivery = lazy(() => import("./source/screens/CreateExpressDelivery"));
  const CreateEmployee = lazy(() => import("./source/screens/CreateEmployee"));
    const MyJobs = lazy(() => import("./source/screens/MyJobs"));
  const HoursWorked = lazy(() => import("./source/screens/HoursWorked"));
const LogisticMain = lazy(() =>
  import("./source/components/Web-Screens/Logistic-Service/LogisticMain")
);

const SecurityMain = lazy(() =>
  import("./source/components/Web-Screens/Security-Service/SecurityMain")
);

const CleaningMain = lazy(() =>
  import("./source/components/Web-Screens/Cleaning-Services/CleaningMain")
);

const StaffMain = lazy(() =>
  import("./source/components/Web-Screens/Staff-Service/StaffMain")
);

const CandidateMain = lazy(() =>
  import("./source/components/Web-Screens/Candidate/CandidateMain")
);

const ContactUs = lazy(() =>
  import("./source/components/Web-Screens/Contact-Us/ContactMain")
);

const Privacy = lazy(() =>
  import("./source/components/Web-Screens/Privacy-Policy/PrivacyMain")
);




export default function App() {
  const navigate = useNavigate();
  const [{}, dispatch] = useStateValue();

  


  const location = useLocation();
  useEffect(() => {
    window.scroll(0, 0);
  }, [location]);

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid;
        getuserdata(uid);
      } else {
        if (
          location.pathname != "/privacypolicy" &&
          location.pathname != "/privacy-policy" &&
          location.pathname != "/candidate-service" &&
          location.pathname != "/cleaning-service" &&
          location.pathname != "/contact-us" &&
          location.pathname != "/logistic-service" &&
          location.pathname != "/security-service" &&
          location.pathname != "/staff-service"
        ) {
          navigate("/");
        }
      }
    });
    //     // Check if user data exists in local storage
    //     const user = localStorage.getItem('user');
    //     if (user) {
    //       dispatch({
    //         type: actionType.SET_USER,
    //         payload: JSON.parse(user)
    //       })
    // if(location.pathname != "/privacypolicy"){
    //   navigate("/home")
    // }

    //     } else {
    //       if(location.pathname != "/privacypolicy"){
    //       navigate("/")
    //      }

    //     }
  }, []);

  async function getuserdata(id) {
    await getuserinformation("users", id)
      .then(async (response) => {
        if (response?.delete || response?.disabled) {
          const auth = getAuth();
          signOut(auth)
            .then(() => {
              dispatch({
                type: actionType.SET_USER,
                payload: [],
              });
              navigate("/");
            })
            .catch((error) => {
              alert("sign out error");
            });
        } else {
          dispatch({
            type: actionType.SET_USER,
            payload: response,
          });
          if (
            location.pathname != "/privacypolicy" &&
            location.pathname != "/privacy-policy" &&
            location.pathname != "/candidate-service" &&
            location.pathname != "/cleaning-service" &&
            location.pathname != "/contact-us" &&
            location.pathname != "/logistic-service" &&
            location.pathname != "/security-service" &&
            location.pathname != "/staff-service"
          ) {
            navigate("/home");
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }


  useEffect(() => {
  const unsubscribe = onMessage(messaging, (payload) => {
       startTransition(() => {
    toast(<Message notification={payload.notification} />);
  })
  });

  return () => unsubscribe?.();
}, []);


  return (
    <HelmetProvider>
      <div className="w-full flex flex-col bg-themeColor">
     
  {location.pathname == "/" || location.pathname == "/logistic-service" || location.pathname == "/security-service" || location.pathname == "/cleaning-service" || location.pathname == "/staff-service"  || location.pathname == "/candidate-service"  || location.pathname == "/contact-us" ? <HeaderPublic /> : location.pathname != "/privacypolicy" &&
          location.pathname != "/privacy-policy" ? <Header /> : null}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          type="error"
          pauseOnHover
          theme="dark"
        />
        <main className="w-full bg-themeColor">
          <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/*" element={<WebScreens />} />
          

  <Route path="/logistic-service" element={<LogisticMain />} />
  <Route path="/security-service" element={<SecurityMain />} />
  <Route path="/cleaning-service" element={<CleaningMain />} />
  <Route path="/staff-service" element={<StaffMain />} />
  <Route path="/candidate-service" element={<CandidateMain />} />
  <Route path="/contact-us" element={<ContactUs />} />
  <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/home" element={<HomeContainer />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/employees" element={<HoursWorked />} />
            <Route path="/CreateEmployee" element={<CreateEmployee />} />
            <Route path="/Slots" element={<Slots />} />
            <Route path="/TaskCreation" element={<TaskCreation />} />
            <Route path="/CreateProject" element={<CreateProject />} />
            <Route path="/CreateVehichle" element={<CreateVehichle />} />
            <Route path="/ToDoList" element={<ToDolist />} />
            <Route path="/CreatCustomer" element={<CreatCustomer />} />
            <Route path="/MarketPlace" element={<MarketPlace />} />
            <Route path="/LeaveRequest" element={<LeaveRequest />} />
            <Route path="/MyJobs" element={<MyJobs />} />
            <Route path="/UpdateSlot" element={<UpdateSlot />} />

            <Route path="/Blogs" element={<Blogs />} />
            <Route
              path="/AddEmployeeToProject"
              element={<AddEmployeeToProject />}
            />

            <Route
              path="/ProjectDesignations"
              element={<ProjectDesignations />}
            />

      <Route
              path="/ProjectEmployees"
              element={<ProjectEmployees />}
            />

            <Route
              path="/CreateEmployeeSchedule"
              element={<CreateEmployeeSchedule />}
            />
            <Route
              path="/CreateExpressDelivery"
              element={<CreateExpressDelivery />}
            />

            <Route path="/CreateWorkOrder" element={<CreateWorkOrder />} />
            <Route path="/Messages" element={<Messages />} />
            <Route path="/EditProject" element={<EditProject />} />

            {/* <Route path="/helpinner" element={<HelpInner />} />
          <Route path="/help" element={<Help />} />
          <Route path="/cookiepolicy" element={<CookiePolicy />} /> */}
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            {/* <Route path="/termsuse" element={<TermsUse />} /> */}
            <Route element={<NotFound />} />
          </Routes>
          </Suspense>
        </main>

            {location.pathname == "/" || location.pathname == "/logistic-service" || location.pathname == "/security-service" || location.pathname == "/cleaning-service" || location.pathname == "/staff-service"  || location.pathname == "/candidate-service"  || location.pathname == "/contact-us"  ?  <Footer /> : null}
        {/* {!isLoginRoute && !isMessageRoute && <Footer/>} */}
      </div>
    </HelmetProvider>
  );
}
